import { jsx as _jsx } from "react/jsx-runtime";
import { useScreenSize } from "app/lib/useScreenSize";
import DesktopTransactionList from "./DesktopTransactionList";
import MobileTransactionList from "./MobileTransactionList";
import RecentActivityList from "./DesktopTransactionList/RecentActivityList";
const TransactionListView = ({ account, setDetailView, }) => {
    const screenSize = useScreenSize();
    const isRoot = window.location.pathname === "/";
    if (screenSize === "desktop" && isRoot) {
        return _jsx(RecentActivityList, { account: account });
    }
    else if (screenSize === "desktop") {
        return (_jsx(DesktopTransactionList, { accountId: account?.Id, accountNumber: account?.Number }));
    }
    else {
        return (_jsx(MobileTransactionList, { account: account, setDetailView: setDetailView }));
    }
};
export default TransactionListView;
